import React from "react";
import Layout from "../../Components/Global/Layout";
import BreadCrumb from '../../Components/Global/BreadCrumb/BreadCrumb';
import BlogAdd from "../../Components/Blog/BlogAdd/BlogAdd";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useStore } from "../../Utils/utils";

const BlogAddPage = () => {
    const navigate = useNavigate();
    const [storeName, setStoreName] = useState([]);
     const { store, setStore } = useStore();

     useEffect(() => {
            if (storeName?.length == 0 || storeName == undefined) {
                setStoreName(() => [store?.name]);
            } else {
                setStoreName((existingStoreId) => [...existingStoreId, store?.name]);
            }
        }, [store?.id]);
    
        useEffect(() => {
            if (storeName[1] != undefined) {
                if (storeName[0] != storeName[1]) {
                    navigate("/admin");
                    setStoreName([]);
                }
            }
        }, [storeName]);

    return (
        <Layout>
            <div className="breadcrumb-wrapper breadcrumb-contacts">
                <div className="d-flex flex-column">
                    <BreadCrumb />
                </div>
            </div>
            <div className=" card-default">
                <div className="card-body">
                    <BlogAdd />
                </div>
            </div>
        </Layout>
    )
}
export default BlogAddPage;
